// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Hide main sidebar when "new chat" or "forward message" is open */
.roq-chat-sidebar__sidebar:not(:last-child) {
  display: none;
}

/* Hide default title */
.roq-chat-conversation-list-sidebar__header__top__title {
  display: none;
}

.roq-chat-conversation-card {
  border-radius: var(--border-radius-huge);
  display: flex;
  min-height: var(--preference-select-item-min-height);
  padding: var(--spacing-small);
}

.roq-chat-conversation-card:focus-visible {
  background-color: var(--color-grey-dark);
  /* Remove global style  for focus-visible */
  box-shadow: none;
}

.roq-chat-conversation-card:hover {
  background-color: var(--color-hover-day-light);
}

.roq-chat-conversation-card--selected {
  background-color: var(--color-blue-lighter);
  font-weight: var(--font-semibold);
}

.roq-chat-conversation-card--selected:hover,
.roq-chat-conversation-card--selected:focus-visible {
  background-color: var(--color-blue-light);
}

/* Sidebar conversation */
.roq-chat-conversation-card__inner {
  align-items: center;
  display: flex;
  gap: var(--spacing-small);
  padding-right: var(--spacing-medium);
  width: 100%;
}

/* Sidebar conversation text (name, latest message, date) */
.roq-chat-conversation-card__inner__info {
  -webkit-box-orient: vertical;
  display: -webkit-box;
  flex-grow: 1;
  -webkit-line-clamp: var(--preference-label-line-clamp);
  overflow: hidden;
  text-wrap: wrap;
}

/* Sidebar conversation latest message */
.roq-chat-conversation-card__inner__info__message {
  display: none;
}
/* Sidebar conversation date of the latest message */
.roq-chat-conversation-card__inner__info__timestamp {
  display: none;
}

/* TODO: Uncomment if we want to show the latest message in conversation list items */

/* Sidebar conversation person name */
/* .roq-chat-conversation-card-title {
  font-size: var(--font-baseline);
}

.roq-chat-conversation-card__inner__info__message {
  font-size: var(--font-sm);
  font-style: italic;
}

.roq-chat-conversation-card__inner__info__message p,
.roq-chat-conversation-card__inner__info__message
  .roq-chat-typing-indicator__text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
} */

/* Display only the first paragraph in the latest message preview */
/* .roq-chat-conversation-card__inner__info__message__body p:not(:first-child) {
  display: none;
} */

/* When a conversation has unread messages */
/* .roq-chat-conversation-card--unread
  .roq-chat-conversation-card__inner__info__message {
  color: var(--color-primary-light);
} */

/* Red circle with the number of unread messages */
.roq-chat-conversation-card--unread
  .roq-chat-conversation-card__inner__actions {
  align-items: center;
  background-color: var(--color-background-notification);
  border-radius: var(--border-radius-huge);
  color: var(--color-text-alt);
  display: flex;
  flex-shrink: 0;
  font-size: var(--font-avatar);
  font-weight: var(--font-semibold);
  height: var(--size-indicator-icon);
  justify-content: center;
  margin-left: var(--spacing-tiny);
  width: var(--size-indicator-icon);
}
`, "",{"version":3,"sources":["webpack://./src/styles/css/roqChat/_sidebar-conversation-list.css"],"names":[],"mappings":"AAAA,mEAAmE;AACnE;EACE,aAAa;AACf;;AAEA,uBAAuB;AACvB;EACE,aAAa;AACf;;AAEA;EACE,wCAAwC;EACxC,aAAa;EACb,oDAAoD;EACpD,6BAA6B;AAC/B;;AAEA;EACE,wCAAwC;EACxC,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,2CAA2C;EAC3C,iCAAiC;AACnC;;AAEA;;EAEE,yCAAyC;AAC3C;;AAEA,yBAAyB;AACzB;EACE,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,oCAAoC;EACpC,WAAW;AACb;;AAEA,2DAA2D;AAC3D;EACE,4BAA4B;EAC5B,oBAAoB;EACpB,YAAY;EACZ,sDAAsD;EACtD,gBAAgB;EAChB,eAAe;AACjB;;AAEA,wCAAwC;AACxC;EACE,aAAa;AACf;AACA,oDAAoD;AACpD;EACE,aAAa;AACf;;AAEA,qFAAqF;;AAErF,qCAAqC;AACrC;;;;;;;;;;;;;;;GAeG;;AAEH,mEAAmE;AACnE;;GAEG;;AAEH,4CAA4C;AAC5C;;;GAGG;;AAEH,kDAAkD;AAClD;;EAEE,mBAAmB;EACnB,sDAAsD;EACtD,wCAAwC;EACxC,4BAA4B;EAC5B,aAAa;EACb,cAAc;EACd,6BAA6B;EAC7B,iCAAiC;EACjC,kCAAkC;EAClC,uBAAuB;EACvB,gCAAgC;EAChC,iCAAiC;AACnC","sourcesContent":["/* Hide main sidebar when \"new chat\" or \"forward message\" is open */\n.roq-chat-sidebar__sidebar:not(:last-child) {\n  display: none;\n}\n\n/* Hide default title */\n.roq-chat-conversation-list-sidebar__header__top__title {\n  display: none;\n}\n\n.roq-chat-conversation-card {\n  border-radius: var(--border-radius-huge);\n  display: flex;\n  min-height: var(--preference-select-item-min-height);\n  padding: var(--spacing-small);\n}\n\n.roq-chat-conversation-card:focus-visible {\n  background-color: var(--color-grey-dark);\n  /* Remove global style  for focus-visible */\n  box-shadow: none;\n}\n\n.roq-chat-conversation-card:hover {\n  background-color: var(--color-hover-day-light);\n}\n\n.roq-chat-conversation-card--selected {\n  background-color: var(--color-blue-lighter);\n  font-weight: var(--font-semibold);\n}\n\n.roq-chat-conversation-card--selected:hover,\n.roq-chat-conversation-card--selected:focus-visible {\n  background-color: var(--color-blue-light);\n}\n\n/* Sidebar conversation */\n.roq-chat-conversation-card__inner {\n  align-items: center;\n  display: flex;\n  gap: var(--spacing-small);\n  padding-right: var(--spacing-medium);\n  width: 100%;\n}\n\n/* Sidebar conversation text (name, latest message, date) */\n.roq-chat-conversation-card__inner__info {\n  -webkit-box-orient: vertical;\n  display: -webkit-box;\n  flex-grow: 1;\n  -webkit-line-clamp: var(--preference-label-line-clamp);\n  overflow: hidden;\n  text-wrap: wrap;\n}\n\n/* Sidebar conversation latest message */\n.roq-chat-conversation-card__inner__info__message {\n  display: none;\n}\n/* Sidebar conversation date of the latest message */\n.roq-chat-conversation-card__inner__info__timestamp {\n  display: none;\n}\n\n/* TODO: Uncomment if we want to show the latest message in conversation list items */\n\n/* Sidebar conversation person name */\n/* .roq-chat-conversation-card-title {\n  font-size: var(--font-baseline);\n}\n\n.roq-chat-conversation-card__inner__info__message {\n  font-size: var(--font-sm);\n  font-style: italic;\n}\n\n.roq-chat-conversation-card__inner__info__message p,\n.roq-chat-conversation-card__inner__info__message\n  .roq-chat-typing-indicator__text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n} */\n\n/* Display only the first paragraph in the latest message preview */\n/* .roq-chat-conversation-card__inner__info__message__body p:not(:first-child) {\n  display: none;\n} */\n\n/* When a conversation has unread messages */\n/* .roq-chat-conversation-card--unread\n  .roq-chat-conversation-card__inner__info__message {\n  color: var(--color-primary-light);\n} */\n\n/* Red circle with the number of unread messages */\n.roq-chat-conversation-card--unread\n  .roq-chat-conversation-card__inner__actions {\n  align-items: center;\n  background-color: var(--color-background-notification);\n  border-radius: var(--border-radius-huge);\n  color: var(--color-text-alt);\n  display: flex;\n  flex-shrink: 0;\n  font-size: var(--font-avatar);\n  font-weight: var(--font-semibold);\n  height: var(--size-indicator-icon);\n  justify-content: center;\n  margin-left: var(--spacing-tiny);\n  width: var(--size-indicator-icon);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
